import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { Accordion } from '../components/Accordion';
import { testimonials } from '../components/testimonials';
export function ProviSystem() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-754">
      {/* SECTION 1 — HERO OFERTĂ */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32 text-center" data-id="element-755">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-756"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-757"></div>
        <div className="max-w-[900px] mx-auto px-5 md:px-12 relative z-10" data-id="element-758">
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-759">
            Implementare ProVi System în Compania Ta
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-760">
            Sistemul care scoate afacerea din dependența de tine și o pune pe
            pilot automat.
          </p>
          <BookingButton text="Aplică pentru o Discuție de Diagnostic" href="#oferta" className="px-10 py-5 text-[16px]" data-id="element-761" />
        </div>
      </section>

      {/* SECTION 2 — DESCRIERE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-762">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-763">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8 text-center" data-id="element-764">
            Ai construit o afacere. Acum ești captiv în ea.
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-765">
            <p data-id="element-766">
              Ești antreprenor cu echipă, cu clienți, cu o firmă care merge. Dar
              totul trece prin tine. Fiecare decizie, fiecare problemă, fiecare
              urgență.
            </p>
            <p data-id="element-767">
              Ai muncit ani ca să construiești ceva, iar acum simți că afacerea
              te deține pe tine, nu tu pe ea. Nu mai ai timp pentru familie, nu
              mai ai energie pentru strategie și nu mai înțelegi de ce, cu tot
              efortul ăsta, cifra nu crește.
            </p>
            <p data-id="element-768">
              Cu cât trece mai mult timp fără un sistem, cu atât mai greu devine
              să ieși. Echipa se obișnuiește să aștepte decizii de la tine. Tu
              te obișnuiești să fii prezent în fiecare zi.
            </p>
            <p data-id="element-769">
              Afacerea devine tot mai greu de vândut, tot mai greu de delegat și
              tot mai costisitoare în energie. Fiecare an fără sistem este un an
              pierdut din libertatea pe care ți-ai promis-o când ai pornit.
            </p>
            <p className="font-medium text-[#09111F] p-6 bg-[#F1F5F9] rounded-2xl border-l-4 border-[#1D4ED8]" data-id="element-770">
              ProVi System este programul de implementare prin care intrăm în
              compania ta timp de 12 luni și construim, alături de tine și de
              echipa ta de lideri, toate componentele unui business care
              funcționează cu sistem, ritm și responsabilitate.
            </p>
            <p data-id="element-771">
              Nu primești sfaturi. Primești un sistem construit, testat și
              funcțional. La final, afacerea ta merge cu sau fără tine în ea în
              fiecare zi.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3B — FAZELE DE IMPLEMENTARE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-772">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-773">
          <div className="text-center mb-16" data-id="element-774">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-4" data-id="element-775">
              Ce construim împreună în cele 12 luni de implementare
            </h2>
          </div>
          <div className="flex flex-col gap-6" data-id="element-776">
            {[{
            phase: 'Faza 1: Fundație',
            title: 'Pui bazele unui business care știe unde se duce și de ce',
            items: ['Construim viziunea companiei pe 3 ani și o traducem în priorități concrete pentru anul în curs', 'Definești cultura organizațională: valorile care ghidează deciziile și comportamentele în fiecare zi', 'Echipa ta de lideri înțelege pentru prima dată direcția și rolul fiecăruia în atingerea ei']
          }, {
            phase: 'Faza 2: Structură',
            title: 'Pui oamenii potriviți în rolurile potrivite cu responsabilitate clară',
            items: ['Clarificăm organigrama funcțională și fișele de rol astfel încât fiecare om să știe exact ce are de făcut', 'Introducem tabloul de bord cu KPI-urile care contează și învățăm echipa să le urmărească săptămânal', 'Instalăm ritmul de ședințe săptămânale, lunare și trimestriale care țin afacerea în mișcare fără tine prezent']
          }, {
            phase: 'Faza 3: Control',
            title: 'Preiei controlul asupra direcției și scoți afacerea din operațional',
            items: ['Documentăm procesele critice astfel încât orice om din echipă să poată prelua un rol fără să depindă de tine', 'Construim sistemul de identificare și rezolvare a problemelor la cauză, nu la simptom', 'Înveți uneltele concrete prin care conduci compania cu 2-3 ore pe săptămână, nu cu prezența ta zilnică']
          }, {
            phase: 'Faza 4: Autonomie',
            title: 'Afacerea ta funcționează, crește și produce fără implicarea ta zilnică',
            items: ['Echipa de lideri preia conducerea implementării și ia decizii fără să aștepte acordul tău pentru fiecare pas', 'Revii în rolul de strateg al afacerii: te uiți la cifre, ajustezi direcția, construiești viitorul', 'Compania devine scalabilă, vandabilă și independentă de fondator, exact cum ți-ai dorit când ai pornit']
          }].map((phase, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-[rgba(0,0,0,0.04)] flex flex-col md:flex-row gap-8 items-start" data-id="element-777">
                <div className="flex items-center justify-center w-14 h-14 rounded-full border-4 border-white bg-[#1D4ED8] text-white font-bold shadow shrink-0 text-xl" data-id="element-778">
                  {index + 1}
                </div>
                <div className="flex-1" data-id="element-779">
                  <span className="font-['Montserrat'] text-[13px] font-bold tracking-[0.1em] uppercase text-[#3B82F6] mb-2 block" data-id="element-780">
                    {phase.phase}
                  </span>
                  <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-4" data-id="element-781">
                    {phase.title}
                  </h3>
                  <ul className="space-y-3" data-id="element-782">
                    {phase.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-783">
                        <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-784"></div>
                        <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-785">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 4 — BENEFICII */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-786">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-787">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-788">
            Ce obții concret după 12 luni de implementare ProVi System
          </h2>
          <div className="flex flex-col gap-6" data-id="element-789">
            {[{
            title: 'Timp real recuperat din operațional',
            desc: 'Reduci implicarea ta zilnică în operațional cu 50 până la 70 de procente, măsurat în ore per săptămână. Ore pe care le reiei pentru strategie, familie sau ce contează pentru tine.'
          }, {
            title: 'O echipă care își asumă',
            desc: 'Liderii tăi știu ce au de făcut, cum sunt măsurați și față de cine răspund. Nu mai vin la tine pentru fiecare decizie mică.'
          }, {
            title: 'Claritate completă asupra direcției',
            desc: 'Viziunea, cultura și strategia companiei sunt documentate, comunicate și înțelese de toată echipa. Toți trag în aceeași direcție.'
          }, {
            title: 'Cifre care îți arată adevărul',
            desc: 'Un tablou de bord simplu cu 5 până la 7 indicatori cheie urmăriți săptămânal. Conduci pe cifre reale, nu pe sentimente sau impresii.'
          }, {
            title: 'Procese documentate care nu depind de oameni',
            desc: 'Activitățile critice sunt documentate în SOP-uri clare. Dacă un om pleacă, procesul rămâne. Afacerea nu se oprește.'
          }, {
            title: 'Un sistem de marketing și vânzări aliniat',
            desc: 'Înțelegi exact ce strategie de creștere se potrivește etapei tale și unde să îți concentrezi resursele pentru rezultate maxime.'
          }, {
            title: 'O companie pregătită să fie scalată sau vândută',
            desc: 'Indiferent dacă vrei să crești, să delegi total sau să faci exit în câțiva ani, compania ta va fi structurată corect pentru orice dintre aceste obiective.'
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-6 border border-[rgba(0,0,0,0.04)]" data-id="element-790">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mb-4 text-[#1D4ED8] shadow-sm" data-id="element-791">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-792">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-793"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] mb-2" data-id="element-794">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-795">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-796">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-797">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-798">
            <div className="relative" data-id="element-799">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-800"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fWFHPTDBhfM1RiRRjS7QNx/Valer_1.jpg" alt="Valer Dura" className="relative z-10 w-full max-w-[450px] mx-auto rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl" data-id="element-801" />
            </div>
            <div data-id="element-802">
              <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8 text-left" data-id="element-803">
                De ce am credibilitatea să construiesc sistemul ăsta în compania
                ta
              </h2>
              <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] text-left" data-id="element-804">
                <p data-id="element-805">
                  Sunt Valer Dura și am construit, eficientizat și vândut
                  propriile afaceri cu cifre de milioane de euro. Nu am ajuns la
                  implementare de sisteme prin teorie sau certificări. Am ajuns
                  prin experiența directă de a fi fost acel antreprenor captiv
                  în propria firmă, care lua toate deciziile, stingea toate
                  incendiile și se întreba de ce, cu tot efortul depus,
                  creșterea stagnase.
                </p>
                <p data-id="element-806">
                  Am înțeles că problema nu era lipsa de efort. Era lipsa
                  sistemului. Și am construit ProVi System ca răspuns la exact
                  această problemă.
                </p>
                <p data-id="element-807">
                  De 12 ani lucrez direct cu antreprenori mici și mijlocii din
                  România. Nu cu teorie predată în sală. Vin în compania ta,
                  lucrez cu echipa ta de lideri și construiesc fiecare
                  componentă a sistemului până când funcționează în realitate,
                  nu pe hârtie. Sunt certificat Maxwell Leadership, am
                  certificare DISC pentru profilare de echipe și am pregătire
                  specializată în coaching și mentoring pentru antreprenori.
                </p>
                <p className="font-medium text-white border-l-4 border-[#3B82F6] pl-6 py-2" data-id="element-808">
                  Ceea ce nu se poate cumpăra cu nicio certificare este
                  experiența de a fi construit și vândut companii reale. Aceea o
                  aduc în fiecare engagement pe care îl accept.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-809">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-810">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-811">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-812">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-813">
                <div className="w-8 h-8 rounded-full bg-[#1D4ED8] text-white flex items-center justify-center" data-id="element-814">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-815">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-816"></path>
                  </svg>
                </div>
                ProVi System este pentru tine dacă
              </h3>
              <ul className="space-y-4" data-id="element-817">
                {['Conduci o companie cu minimum 3 angajați și simți că totul depinde de tine pentru a merge', 'Ai o echipă, dar echipa nu funcționează la potențial fără implicarea ta zilnică', 'Muncești la fel de mult ca acum 2-3 ani, dar cifra de afaceri nu mai crește proporțional', 'Vrei să îți construiești afacerea astfel încât să poți să o scalezi, să o delegi sau să o vinzi'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-818">
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-819"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-820">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-821">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-822">
                <div className="w-8 h-8 rounded-full bg-[#EF4444] text-white flex items-center justify-center" data-id="element-823">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-824">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-825"></path>
                  </svg>
                </div>
                ProVi System nu este pentru tine dacă
              </h3>
              <ul className="space-y-4" data-id="element-826">
                {['Ești în faza de lansare sau ai sub 3 angajați, sistemul nu se aplică încă la dimensiunea ta', 'Cauți o soluție rapidă de 1-2 luni sau o intervenție punctuală pe un singur departament', 'Nu ești dispus să lucrezi cu cifre, să respecți un ritm de ședințe și să iei decizii dificile legate de oameni', 'Vrei ca altcineva să rezolve problemele în locul tău fără implicarea ta activă în proces'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-827">
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-828"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-829">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — RECAPITULARE INVESTIȚIE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-830">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-831">
          <div id="oferta" className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative scroll-mt-24" data-id="element-832">
            <div className="absolute -top-5 inset-x-0 flex justify-center" data-id="element-833">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-834">
                RECAPITULARE
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-8 text-center mt-4" data-id="element-835">
              Hai să recapitulăm ce primești în cei 12 luni de implementare
              ProVi System
            </h2>

            <div className="flex flex-col gap-10" data-id="element-836">
              <div data-id="element-837">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6 border-b pb-2" data-id="element-838">
                  Ce este inclus:
                </h3>
                <ul className="space-y-4" data-id="element-839">
                  {['Ședința anuală de planificare: o zi întreagă în care confirmăm viziunea, obiectivele anului și prioritățile strategice', '12 sesiuni lunare 1 la 1 cu Valer: câte 60 de minute pe lună, orientate spre claritate în decizii, leadership și menținerea focusului pe ce contează', '12 sesiuni lunare cu echipa de lideri: câte 2 ore pe lună dedicate alinierii echipei, urmăririi implementării și responsabilizării', '4 sesiuni trimestriale de evaluare și ajustare: la începutul fiecărui trimestru, review complet al progresului și stabilirea noilor priorități', 'Acces între ședințe pe WhatsApp și email cu răspuns în aceeași zi lucrătoare pentru decizii importante sau blocaje apărute între întâlniri', 'Kit ProVi System complet în care primești toate template-urile, instrumentele și ghidurile de lucru pentru fiecare componentă a sistemului'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-840">
                      <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-841">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-842"></path>
                      </svg>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-843">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-844">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#F59E0B] mb-6 border-b pb-2" data-id="element-845">
                  Bonusuri:
                </h3>
                <ul className="space-y-4 mb-8" data-id="element-846">
                  {['Sesiune de profilare DISC pentru echipa de lideri: înțelegi cum comunică, ce îi motivează și cum să îi pui în rolurile potrivite', 'Acces la biblioteca de resurse ProVi System: video-uri de training, ghiduri de implementare și studii de caz din companii românești similare cu a ta', 'Sesiune de diagnostic de exit sau scalare: la finalul celor 12 luni, evaluăm împreună opțiunile de creștere, delegare sau vânzare potrivite pentru compania ta'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-847">
                      <svg className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-848">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" data-id="element-849"></path>
                      </svg>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-850">
                        {item}
                      </span>
                    </li>)}
                </ul>
                <div className="bg-[#FEF2F2] rounded-xl p-6 border border-[rgba(239,68,68,0.2)]" data-id="element-851">
                  <p className="font-['Montserrat'] text-[14px] font-bold text-[#EF4444] uppercase tracking-wider mb-2" data-id="element-852">
                    IMPORTANT:
                  </p>
                  <p className="font-['Inter'] text-[16px] text-[#4B5563]" data-id="element-853">
                    Program cu număr limitat de locuri active simultan. Valer
                    lucrează cu maximum 20 companii în același timp pentru a
                    garanta calitatea implementării.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-854">
              <BookingButton text="Aplică pentru o Discuție de Diagnostic" href="/contact" className="px-10 py-5 text-[16px] w-full sm:w-auto" data-id="element-855" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — TESTIMONIALE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-856">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-857">
          <div className="text-center mb-16" data-id="element-858">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-859">
              Ce spun antreprenorii care au implementat ProVi System în compania
              lor
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-860">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-861" />)}
          </div>
        </div>
      </section>

      {/* SECTION 9 — ÎNTREBĂRI FRECVENTE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-862">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-863">
          <div className="text-center mb-16" data-id="element-864">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-865">
              Întrebări Frecvente
            </h2>
          </div>
          <Accordion items={[{
          question: 'Cât timp îmi ia mie pe săptămână?',
          answer: 'Aproximativ 8 ore pe lună pentru sesiunile programate cu Valer și echipa lui. În plus, 45 până la 60 de minute pe săptămână pentru ședința internă de progres cu echipa ta. Nu e mult, dar trebuie să fie constant. Ritmul este cel care produce rezultatele.'
        }, {
          question: 'Ce se întâmplă dacă echipa mea nu cooperează cu implementarea?',
          answer: 'Rezistența la schimbare este normală și e una dintre zonele pe care le adresăm explicit în program. Valer lucrează direct cu echipa ta de lideri, nu doar cu tine. Construim împreună contextul care face ca oamenii să adopte sistemul din înțelegere, nu din presiune.'
        }, {
          question: 'Este garantat că voi vedea rezultate?',
          answer: 'La finalul primului trimestru facem o evaluare formală împreună. Dacă nu există progres real și măsurabil, poți ieși din program fără obligații pentru lunile rămase. Valer acceptă doar clienți în care crede că sistemul produce rezultate concrete.'
        }, {
          question: 'Cum e diferit față de un consultant sau un coach obișnuit?',
          answer: 'Un consultant îți dă un raport cu recomandări. Un coach te întreabă cum te simți. Valer vine în compania ta, lucrează cu echipa ta de lideri și construiește sistemul pas cu pas. Nu pleci cu un document. Pleci cu o companie care funcționează diferit.'
        }, {
          question: 'Funcționează și în domeniul meu?',
          answer: 'ProVi System este construit pe principii de conducere care se aplică oricărei afaceri cu echipă, indiferent de domeniu. Provocările de viziune neclară, roluri confuze, cifre nemonitorizate și ritm absent apar în construcții, comerț, servicii și producție deopotrivă.'
        }, {
          question: 'Când pot începe?',
          answer: 'Totul pornește de la o sesiune de diagnostic gratuit de 30 de minute. Acolo înțelegem contextul afacerii tale, identificăm blocajele principale și vedem împreună dacă programul este potrivit. Dacă da, stabilim data de start și trimiți kitului ProVi System la tine.'
        }, {
          question: 'Pot plăti în rate?',
          answer: 'Da. Programul poate fi achitat integral cu preț special pentru plată integrală, în 4 rate trimestriale sau în 12 rate lunare (fără preț special). Detaliile exacte le discutăm în sesiunea de diagnostic, după ce stabilim că programul este potrivit pentru situația ta.'
        }]} data-id="element-866" />
        </div>
      </section>
    </div>;
}